<template>
    <td>
        <v-chip class="mr-2" v-for="garage in garages" :key="garage">{{garage}}</v-chip>
        <v-chip v-if="value.length > displayCount">+ {{value.length - displayCount}}</v-chip>
    </td>
</template>
<script>
export default {
    props: {
        value: { required: true },
      displayCount: { required: true }
    },
    computed: {
        garages() {
            return this.value.slice(0, this.displayCount);
        }
    }
};
</script>
